/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Video_Export_Preview_FailedInputs */

const en_video_export_preview_failed = /** @type {(inputs: Video_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preview generation failed: ${i?.error}`)
};

const fr_video_export_preview_failed = /** @type {(inputs: Video_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la generation de la previsualisation : ${i?.error}`)
};

const de_video_export_preview_failed = /** @type {(inputs: Video_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vorschau-Generierung fehlgeschlagen: ${i?.error}`)
};

const it_video_export_preview_failed = /** @type {(inputs: Video_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generazione dell'anteprima non riuscita: ${i?.error}`)
};

const ru_video_export_preview_failed = /** @type {(inputs: Video_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось создать предварительный просмотр: ${i?.error}`)
};

const es_video_export_preview_failed = /** @type {(inputs: Video_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la generación de la vista previa: ${i?.error}`)
};

const zh_cn2_video_export_preview_failed = /** @type {(inputs: Video_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`预览生成失败：${i?.error}`)
};

const ja_video_export_preview_failed = /** @type {(inputs: Video_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プレビュー生成に失敗しました: ${i?.error}`)
};

const hi_video_export_preview_failed = /** @type {(inputs: Video_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन निर्माण विफल: ${i?.error}`)
};

const pt_pt2_video_export_preview_failed = /** @type {(inputs: Video_Export_Preview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A geração da pré-visualização falhou: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Preview generation failed: {error}" |
*
* @param {Video_Export_Preview_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_failed = /** @type {((inputs: Video_Export_Preview_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_failed(inputs)
	if (locale === "de") return de_video_export_preview_failed(inputs)
	if (locale === "it") return it_video_export_preview_failed(inputs)
	if (locale === "ru") return ru_video_export_preview_failed(inputs)
	if (locale === "es") return es_video_export_preview_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_failed(inputs)
	if (locale === "ja") return ja_video_export_preview_failed(inputs)
	if (locale === "hi") return hi_video_export_preview_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_failed(inputs)
	return en_video_export_preview_failed(inputs)
});